import { Container, Graphics, Text, Sprite, Texture } from "pixi.js";
import type { TileVisual } from "../theme/types";

// 单个方块的可视对象。pivot 在中心，方便做缩放/旋转类的消除动画。
// 支持三种视觉策略：贴图(Sprite) / emoji(Text) / 程序化色块(Graphics)。
export class TileSprite extends Container {
  gx: number;
  gy: number;
  kind = -1;

  private card = new Graphics();
  private content: Container | null = null;

  constructor(gx: number, gy: number) {
    super();
    this.gx = gx;
    this.gy = gy;
    this.addChild(this.card);
  }

  /** 根据视觉定义与当前格子尺寸重绘整个方块。 */
  paint(kind: number, visual: TileVisual, size: number, cardColor: number): void {
    this.kind = kind;

    // 底板卡片
    this.card.clear();
    const half = size / 2;
    const radius = size * 0.22;
    if (visual.shape) {
      // 程序化色块：底板即主色，叠一层高光让它更立体
      this.card.roundRect(-half, -half, size, size, radius).fill({ color: visual.tint ?? 0x888888 });
      this.card
        .roundRect(-half + size * 0.14, -half + size * 0.12, size * 0.72, size * 0.34, radius * 0.6)
        .fill({ color: 0xffffff, alpha: 0.18 });
    } else {
      this.card.roundRect(-half, -half, size, size, radius).fill({ color: cardColor });
    }

    // 内容层
    if (this.content) {
      this.content.destroy({ children: true });
      this.content = null;
    }
    if (visual.texture) {
      const sprite = new Sprite(Texture.from(visual.texture));
      sprite.anchor.set(0.5);
      const target = size * 0.78;
      const scale = target / Math.max(sprite.texture.width, sprite.texture.height);
      sprite.scale.set(scale);
      this.content = sprite;
      this.addChild(sprite);
    } else if (visual.emoji) {
      const text = new Text({
        text: visual.emoji,
        style: { fontSize: Math.round(size * 0.6), fill: 0xffffff, align: "center" },
      });
      text.anchor.set(0.5);
      this.content = text;
      this.addChild(text);
    }
    // shape 策略无额外内容层

    this.scale.set(1);
    this.alpha = 1;
    this.rotation = 0;
  }
}
